// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Arrow: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M47.8 24.7H8.2l6.6-6.6c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-.5-.5c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3l-9.3 9.2c-.4.4-.4 1 0 1.4l9.2 9.2c.2.2.4.3.7.3.3 0 .5-.1.7-.3l.5-.5c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7l-6.6-6.6h39.6c.6 0 1-.4 1-1v-.7c0-.9-.5-1.1-.9-1.1zm-34.2-8.4c.1 0 .2 0 .3.2 0-.2-.1-.2-.3-.2s-.2 0-.3.2c.1-.2.2-.2.3-.2zm-.1 19.4c-.1 0-.2 0-.4-.2.2.1.3.2.4.2s.2-.1.3-.2c0 .2-.1.2-.3.2z"/></svg>;
};

export default React.memo(Arrow);
